import { render, staticRenderFns } from "./comOrderStatus.vue?vue&type=template&id=2b731ad9&scoped=true"
import script from "./comOrderStatus.vue?vue&type=script&lang=js"
export * from "./comOrderStatus.vue?vue&type=script&lang=js"
import style0 from "./comOrderStatus.vue?vue&type=style&index=0&id=2b731ad9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b731ad9",
  null
  
)

export default component.exports